import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { AuthStateModel } from '@core/states/auth.state';

/**
 * @title Token Interceptor
 * @since 1.0.0
 * 
 * @description This interceptor adds the JWT token to the Authorization header of outgoing HTTP requests.
 * It retrieves the token from the NGXS store and attaches it to the request if available.
 * This is essential for authenticating requests to protected API endpoints.
 */
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
	
	const store = inject(Store);
	const token = store.selectSnapshot((state: { auth: AuthStateModel }) => state.auth.token);

	if (token) {
		req = req.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`
			}
		});
	}

	return next(req);
};
